import * as yup from 'yup'

export const validateCreateIpAccessRules = yup.object().shape({
  ip: yup
    .string()
    .required('Campo requerido.')
    .min(7, 'IP inválida'),
  type: yup
    .string()
    .oneOf(['block', 'allow'], 'Tipo inválido')
    .required('Campo requerido.'),
  reason: yup.string().nullable(),
  status: yup.string().oneOf(['active', 'inactive']).nullable(),
})

export const validateUpdateIpAccessRules = yup.object().shape({
  ip: yup
    .string()
    .required('Campo requerido.')
    .min(7, 'IP inválida'),
  type: yup
    .string()
    .oneOf(['block', 'allow'], 'Tipo inválido')
    .required('Campo requerido.'),
  reason: yup.string().nullable(),
  status: yup.string().oneOf(['active', 'inactive']).nullable(),
})
